export default __webpack_public_path__ + "static/media/novo.8842ec46.mp4";